<template>
  <div>
    <div
      class="app-vpf pb-10 md:pb-0 app-height bg-velux-white max-w-1280 mx-auto"
      :data-step-id="$store.state.activeStep"
      :data-template-type="$store.state.activeTemplate"
    >
      <section class="py-3 px-5 md:py-12 md:grid mx-auto relative max-w-960">
        <div
          v-if="hasPreviousStep()"
          @click="goPrevStep()"
          class="absolute left-4 top-6 md:top-10 text-2xl cursor-pointer"
        >
          <i class="far fa-arrow-left"></i>
        </div>

        <heading
          v-if="$store.state.activeTemplate !== 'success'"
          :img-src="headingImgUrl"
        >
          <template v-slot:header>
            {{
              $store.state.data.Steps[$store.state.activeStep].Title.replace(
                "${name}",
                $store.state.userInputs.FirstName__c
              )
            }}
          </template>
          <template v-slot:body>
            <div
              v-if="$store.state.data.Steps[$store.state.activeStep].Subtitle"
              v-html="$store.state.data.Steps[$store.state.activeStep].Subtitle"
            ></div>
          </template>
        </heading>
        <vpf-form v-if="$store.state.activeTemplate === 'form'"></vpf-form>

        <!-- flow -->
        <flow-choice v-if="$store.state.activeTemplate === 'flow-choice'" />

        <!-- steps -->
        <address-selection v-if="$store.state.activeTemplate === 'address-selection'" />
        <button-selection v-if="$store.state.activeTemplate === 'button-selection'" />
        <contact-form v-if="$store.state.activeTemplate === 'contact-form'" />
        <success v-if="$store.state.activeTemplate === 'success'" />
        <tile-selection v-if="$store.state.activeTemplate === 'tile-selection'" />
      </section>
    </div>
    <loader v-if="$store.state.isLoading"></loader>
  </div>
</template>
<script>

import AddressSelection from "./components/templates/address-selection";
import ButtonSelection from "./components/templates/button-selection";
import Success from "./components/templates/success";
import TileSelection from "./components/templates/tile-selection";
import FlowChoice from "./components/templates/flow-choice";
import Form from "./components/templates/form";
import Heading from "./components/shared/Heading";
import Loader from "./components/shared/Loader";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headingImgUrl:"",
      currentActiveIndex:0 // increment or de-increment when moveing between flow steps
    };
  },
  components:{
    Heading,
    AddressSelection,
    ButtonSelection,
    Success,
    TileSelection,
    FlowChoice,
    "vpf-form":Form,
    Loader
  },
  created() {
    const settings = window.veluxProData.settings;

    this.headingImgUrl = settings.ImageUrl;

    let Flows = {};
    let Steps = {};

    settings.Flows.forEach(flow => {
      // normalize Id-s
      let id = flow.Id.replace(/[{}]/g, "").toLowerCase();
      let flowArray = flow.Flow;

      Flows[id] = flowArray.map(flowId =>
        // Selectors for steps in the ARRAY are also ID-s that sometimes are uppercase with curly braces, sometimes not
        flowId.replace(/[{}]/g, "").toLowerCase()
      );
    });

    settings.Steps.forEach(step => {
      // normalize Id-s
      let id = step.Id.replace(/[{}]/g, "").toLowerCase();
      let stepToBuild = (Steps[id] = {});
      let values = Object.values(step);

      Object.keys(step).map(function (key, index) {
        if (key != "Id") {
          stepToBuild[key] = values[index];
        }
      });
    });

    let mappedInstallerData = Object.assign(
      window.veluxProData.settings,
      { Flows: Flows },
      { Steps: Steps },
      {
        FirstStep: window.veluxProData.settings.FirstStep.replace(
          /[{}]/g,
          ""
        ).toLowerCase()
      },
      {
        SecondStep: window.veluxProData.settings.SecondStep.replace(
          /[{}]/g,
          ""
        ).toLowerCase()
      }
    );

    const installerData = {
      language: window.veluxProData.language,
      ...mappedInstallerData
    };

    if (installerData) {
      this.$store.commit("setData", installerData);
    } else {
      console.warn("Error: data is not provided.");
    }
    // setFirstStep - could be firstStep or SecondStep as the first
    this.setFirstStep();
  },
  mounted() {
    this.$store.commit("isInitialising", false);
  },
  computed: {
    ...mapGetters([
      "getActiveStepId"
    ]),
  },
  methods:{
    hasPreviousStep() {
      return this.$store.state.activeTemplate !== 'success' && !this.isStartScreen();
    },
    isStartScreen() {
      return this.getActiveStepId === this.$store.state.data.FirstStep || (this.getActiveStepId === this.$store.state.data.SecondStep && this.$store.state.data.FirstStep === "");
    },
    goPrevStep() {
      this.$store.commit("stepBack");
    },
    setFirstStep() {
      if (this.$store.state.data.FirstStep !== "") {
        this.$store.commit(
          "updateActiveStep",
          this.$store.state.data.FirstStep
        );
        this.$store.commit(
          "setActiveTemplate",
          this.$store.state.data.Steps[this.$store.state.data.FirstStep]
            .StepType
        );
      } else {
        this.$store.commit(
          "updateActiveStep",
          this.$store.state.data.SecondStep
        );
        this.$store.commit(
          "setActiveTemplate",
          this.$store.state.data.Steps[this.$store.state.data.SecondStep]
            .StepType
        );
      }
    }
  }
};
</script>

<style>
.site-section-nav li:first-child a {
  color: #e00;
  font-weight: 700;
}
</style>
